import { render, staticRenderFns } from "./proceedsList.vue?vue&type=template&id=40e74d04&scoped=true&"
import script from "./proceedsList.vue?vue&type=script&lang=js&"
export * from "./proceedsList.vue?vue&type=script&lang=js&"
import style0 from "./proceedsList.vue?vue&type=style&index=0&id=40e74d04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e74d04",
  null
  
)

export default component.exports